import { useLayoutEffect, useRef, useState, useEffect } from "react";
import ClipLoader from "react-spinners/ClipLoader";
import cn from "../utils/cn";
import Stats from "./stats";
import OrderList from "./order_list";
import Totals from "./totals";

import useOrders from "./use_orders";

function Orders() {
  const orders = useOrders();
  const checkbox = useRef();
  const [checked, setChecked] = useState(false);
  const [indeterminate, setIndeterminate] = useState(false);
  const [selectedOrders, setSelectedOrders] = useState([]);
  useLayoutEffect(() => {
    const isIndeterminate =
      selectedOrders.length > 0 && selectedOrders.length < orders.state.length;
    setChecked(
      selectedOrders.length === orders.state.length && orders.state.length > 0
    );
    setIndeterminate(isIndeterminate);
    checkbox.current.indeterminate = isIndeterminate;
  }, [selectedOrders]);

  function toggleAll() {
    setSelectedOrders(
      checked || indeterminate ? [] : orders.state.map((x) => x.order_id)
    );
    setChecked(!checked && !indeterminate);
    setIndeterminate(false);
  }
  return (
    <div className="relative">
      <div
        className={cn(
          !orders.isLoading ? "hidden" : "",
          "fixed top-1/2 left-1/2"
        )}
      >
        <ClipLoader
          color={"#000000"}
          loading={orders.isLoading}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>
      <div className={cn(orders.isLoading ? "hidden" : "")}>
        <div className="xl:flex xl:flex-row-reverse xl:justify-between">
          <Totals
            orders={orders.state}
            selectedOrders={orders.state.filter((x) =>
              selectedOrders.includes(x.order_id)
            )}
          />
          <OrderList
            orders={orders}
            selectedOrders={selectedOrders}
            setSelectedOrders={setSelectedOrders}
            toggleAll={toggleAll}
            checkbox={checkbox}
            checked={checked}
            indeterminate={indeterminate}
          />
        </div>
      </div>
    </div>
  );
}

export function getGroupName(group_id) {
  if (group_id === 1) return <span className="text-green-500">ENERGY</span>;
  if (group_id === 2) return <span className="text-red-400">RELOAD</span>;
  if (group_id === 3) return <span className="text-blue-600">LYTE</span>;
  if (group_id === 4) return "CLOTHES";
  if (group_id === 5) return "DRINKWARE";
  if (group_id === 7) return <span className="text-purple-600">PLUS+</span>;
}
export default Orders;
